import { render } from "./FormCheck.vue?vue&type=template&id=c35726a4"
import script from "./FormCheck.vue?vue&type=script&lang=js"
export * from "./FormCheck.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__